import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.regexp.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import repo from '@/api/system-setting/user';
import dialogMethodMixin from '@/mixins/dialog/method';
export default {
  mixins: [dialogMethodMixin],
  data: function data() {
    var _this = this;
    var MIN = 8;
    var MAX = 16;

    // 校验复杂度
    var validPass = function validPass(rule, value, callback) {
      if (!value) {
        callback(new Error('必填项'));
        return;
      }
      var pwdRegex = new RegExp("(?=.*[0-9])(?=.*[a-zA-Z]){".concat(MIN, ",").concat(MAX, "}"));
      if (!pwdRegex.test(value)) {
        callback(new Error("\u8BF7\u8F93\u5165".concat(MIN, "~").concat(MAX, "\u4F4D\u6570\u5B57\u3001\u5B57\u6BCD\u4E24\u79CD\u7C7B\u578B\u7EC4\u5408")));
      }
      callback();
    };

    // 校验新密码
    var validNewPass = function validNewPass(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入密码'));
        return;
      }
      _this.$refs.refForm.validateField('newPassCheck');
      callback();
    };

    // 校验确认密码
    var validNewPassCheck = function validNewPassCheck(rule, value, callback) {
      if (!value) {
        callback(new Error('请输入确认密码'));
        return;
      }
      if (value !== _this.formData.newPass) {
        callback(new Error('两次输入的密码不一致'));
        return;
      }
      callback();
    };
    return {
      formData: {
        username: null,
        oldPass: null,
        newPass: null,
        newPassCheck: null
      },
      formRules: {
        oldPass: [{
          required: true,
          message: '请输入旧密码',
          trigger: ['blur', 'change']
        }],
        newPass: [{
          required: true,
          message: '请输入密码',
          trigger: ['blur', 'change']
        }, {
          trigger: ['blur'],
          validator: validPass
        }, {
          trigger: ['blur'],
          validator: validNewPass
        }],
        newPassCheck: [{
          required: true,
          message: '请输入确认密码',
          trigger: ['blur', 'change']
        }, {
          trigger: ['blur'],
          validator: validPass
        }, {
          trigger: ['blur'],
          validator: validNewPassCheck
        }]
      }
    };
  },
  created: function created() {
    this.initUser();
  },
  methods: {
    initUser: function initUser() {
      if (!this.$store.getters.user) {
        return;
      }
      this.formData.username = this.$store.getters.user.username;
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      this.$refs['refForm'].validate(function (valid) {
        if (!valid) {
          return;
        }
        _this2.doSubmit();
      });
    },
    doSubmit: function () {
      var _doSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this3 = this;
        var _this$formData, oldPass, newPass, params, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$formData = this.formData, oldPass = _this$formData.oldPass, newPass = _this$formData.newPass;
              params = {
                oldPass: oldPass,
                newPass: newPass
              };
              this.toggleLoading();
              _context.next = 5;
              return repo.updatePassAsync(params);
            case 5:
              result = _context.sent;
              this.toggleLoading();
              if (result) {
                this.$notify({
                  title: '修改成功，请重新登录!',
                  type: 'success',
                  duration: 1500
                });
                setTimeout(function () {
                  _this3.$store.dispatch('LogOut').then(function () {
                    location.reload();
                  });
                }, 1500);
              } else {
                this.$message({
                  message: '修改失败，请重试！',
                  type: 'error'
                });
              }
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function doSubmit() {
        return _doSubmit.apply(this, arguments);
      }
      return doSubmit;
    }()
  }
};